import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { EDIT_INTENT } from './common/constants/intents';
import { LiftMeasurementForm } from './lift-measurement-form';

export const LiftMeasurementEdit = (props) => {
  const { scope } = useContext(ScopeContext);
  const { siteMap } = props;

  useEffect(() => {
    if (scope.values.liftExperimentId == null) {
      const route = getRoutePathById(siteMap, 'lift-measurement');
      scope.remove('liftExperimentId');
      scope.save(route);
    }
  }, [scope, scope.values.liftExperimentId, siteMap]);

  return <LiftMeasurementForm {...props} intent={EDIT_INTENT} />;
};

LiftMeasurementEdit.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
};
